import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from '@angular/common/http';
import { Injectable, Provider, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../services/error/error.service';
import { SHOW_MODAL_ON_ERROR } from '../interceptor.token';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly errorService = inject(ErrorService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SHOW_MODAL_ON_ERROR)) {
      return this.handleError(next, request);
    }
    return next.handle(request);
  }

  private handleError(
    next: HttpHandler,
    request: HttpRequest<unknown>
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          //bei einem BadRequest soll eine Nulltreffer Seite angezeigt werden
          error.status !== HttpStatusCode.BadRequest &&
          // Im Falle von HttpStatusCode.Unauthorized oder Forbidden wird der BaHttpSecurityInterceptorService
          // ein Retry auslösen, da die Ursache für diesen Status ein abgelaufenes OAG-Token ist,
          // welches dabei vom BaHttpSecurityInterceptorService erneuert wird.
          error.status !== HttpStatusCode.Unauthorized &&
          error.status !== HttpStatusCode.Forbidden
        ) {
          this.errorService.setErrorEvent({ text: error.message });
        }
        return throwError(() => error);
      })
    );
  }
}

export function provideErrorInterceptor(): Provider {
  return {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
    deps: [ErrorService]
  };
}
